<template>
  <div class="not-found">
    <div class="error">
      <img :src="errorImg" class="error-img">
    </div>

  </div>
</template>

<script>
import errorImg from '../assets/404.png'

export default {
  name: 'NotFound',
  data () {
    return {
      errorImg: errorImg
    }
  }
}
</script>

<style scoped>
.not-found {
  margin: 16px;
}

.error {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
}

.error-img {
  width: 100%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue